module.exports = __webpack_public_path__ + "static/media/letsdothis.35b2c524.png";